import {getTestProps} from '@benchling/js-test-utils';
import {Tooltip, createStyles, rem} from '@mantine/core';
import React from 'react';

import type {MissingRequiredField} from 'constants/SampleConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {getMissingRequiredFieldsMessage} from './missingRequiredFieldsUtil';
import useShowMissingRequiredFieldWarnings from './useShowMissingRequiredFieldWarnings';

interface Props {
  missingRequiredFields: ReadonlyArray<MissingRequiredField> | null | undefined;
  className?: string;
}

/** Red exclamation icon, with a tooltip naming the fields, for a container missing required values. */
export default function MissingRequiredFieldsIcon({
  missingRequiredFields,
  className,
}: Props): JSX.Element | null {
  const {classes, cx} = useStyles();
  const showWarnings = useShowMissingRequiredFieldWarnings();
  if (!showWarnings || missingRequiredFields == null || missingRequiredFields.length === 0) {
    return null;
  }
  const message = getMissingRequiredFieldsMessage(missingRequiredFields);
  return (
    <Tooltip classNames={{tooltip: classes.tooltip}} label={message} multiline={true} withinPortal={true}>
      <span
        aria-label={message}
        className={cx(classes.icon, className)}
        role="img"
        {...getTestProps({component: 'MissingRequiredFieldsIcon'})}
      >
        <BenchlingIcon aria-hidden={true} icon="exclamation-circle" />
      </span>
    </Tooltip>
  );
}

const useStyles = createStyles((theme) => ({
  icon: {
    color: theme.colors.red[7],
    display: 'inline-flex',
  },
  tooltip: {
    maxWidth: rem(360),
    whiteSpace: 'normal',
  },
}));
